module.exports = __webpack_public_path__ + "img/triangle.735ec811.svg";